import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import getters from './getters'
import AppConfig from '../config/app'

Vue.use(Vuex)

const state = {
  activity: {
    status: true, // 活动进行中
    appid: AppConfig.app.test ? 'wx9594136eabd26d9f' : 'wxef64cfa3a28363ac',
    redirectURL: AppConfig.app.test ? 'http://test.m.wkbins.com/hengqin' : 'http://m.wkbins.com/hengqin',
    innerCodes: ['149673178664394306', '148198068433580000'], // 悟空保测试Code:149673178664394306，正式Code:148198068433580000
    tickets: [], // 所有的优惠券,
    amountBySelectedTickets: 0
  },
  h5: {                                                   // h5配置信息
    configuration: {}                                  // 配置信息
  },
  order: {                                            // 订单
    productId: '',                                     // 产品id 149673981474815463
    userId: '',                                     // 推荐人id 149372307827950272 149666790677721972
    openId: '',                                     // 使用者 oMstTt1wn-Umtw9LXYoGLpu6oMX4
    number: '',                                       // 订单号
    name: '',                          // 产品名称
    company: '',                  // 承保公司
    unionOrderCode: '',
    confirmFeedback: true,                                   // 是否确认回访信息
    countdownTimer: 1800,                              // 保单倒计时，单位是秒
    beneficiary: '法定',                               // 受益人
    paymentMethod: '0',                             // 交费方式
    insurancePeriod: '20',                           // 保险期间
    insuranceAmount: '3',                            // 保障额度
    insuredValue: '1',                                // 给谁投保
    measurePayment: null,                               // 测算的保费
    measureReady: '',                                   // 测试条件是否充足
    paymentByIDNumber: null,                            // 正式保费
    paymentShowNull: '',                                // 保费显示暂无
    paymentPeriod: '20'                               // 交费期间
  },
  holder: {                                           // 投保人
    name: '',                                         // 姓名
    message: '',                                      // 用户留言
    IDNumber: '',                    // 身份证号
    phoneNumber: '',                       // 手机号
    CAPTCHA: '',                                      // 验证码
    realCAPTCHA: '',                                  // 接收到的验证码
    bankName: [],                                     // 银行名称
    bankCardNumber: '',                                    // 银行卡号
    email: '',                                          // 电子邮箱
    area: [],                                         // 所在地区
    positivePicValue: null,
    negativePicValue: null,
    positivePicSrc: '',
    negativePicSrc: '',
    address: ''                                      // 详细地址
  },
  insured: {                                          // 被保险人
    name: '',                                         // 姓名
    sex: '1',
    IDNumber: '',                                     // 身份证号
    IDNumberExpire: '',                     // 身份证有效期
    occupationCode: '4030504',
    occupationName: '一般内勤人员',
    birthday: ''                                      // 出生日期
  },
  wechatpaybanklist: [],
  banksFromServer: []
}

export default new Vuex.Store({
  state,
  getters,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js